import { Calculator, ShowErrorWay } from "../common/calculator";
import { fields as dateFields, baseDateIntervalCheck, DateIntervalField, DateIntervalIgnoreEmptyField, DateField } from "../common/datetime_fields.js";
import { DatePoint, distinctDates, DateSpan, makeDateFromAlertWorker, makeDateInFutureAlertWorker, makeDateSegmentWorker, nextDateAfterWorkingDay } from '../js/datelib.js';
class TFPCalculator extends Calculator {
    code() { return "tfp"; }
    type() { return "CalcTaxPenalty"; }

    initialize() {
        let self = this;
        this.patchFieldTypes([DateField, DateIntervalField, DateIntervalIgnoreEmptyField]);  // add datefields
        this.setupStatistic({
            calcName: 'Penej'
        });

        self.refinRates = undefined;
        $.getJSON("conf/calc_tfp/rates.json?v=" + DataVersionSalt, function (json) {
            self.refinRates = json.refin;
        });

        this._judgementDate = new DatePoint("27.12.2018");
        this.shownRules = [];

        // add input fields
        this.addInputField('#loanSum input', 'loanSum', {
            type: 'money', options: {maxVal: 999999999999.99},
            errors: [{ check: function (v) { return !!v; }, selector: '#loanSum .error-text' }]
        });
        this.addInputField("#paymentTypeInput dropdown-select", 'paymentType', {
            errors: [{ check: function (v) { return v.value !== ''; }, selector: '#paymentTypeInput .error-text' }]
        });
        this.mainPeriodField = this.addInputField('.calc-div-input-main > .period-div', 'mainPeriod', {
            showErrorWay: ShowErrorWay.SHOW_FIRST,
            options: {
                include: {
                    to: function (field) {
                        const v = field.getValue(true);
                        return !field.dateFrom.valid || self.paymentType === undefined || self.includeLastDay(v.dateFrom, self.paymentType.value);
                    }
                }
            }
        });

        function setTemplate($clone, blockPiece) {
            $clone.data('rowIndex', blockPiece.index + 1);

            let $comment = $clone.find('.dynamic-list-comment input').change(function () {
                $(this).data('changed', '1');
            }).focus(tools.selectAllText);

            $comment.val($comment.val() + $clone.data('rowIndex'));

            let $sumInput = $clone.find('.dynamic-list-sum input');
            $sumInput.blur(function () {
                if ($(this).val() === '') {
                    $(this).parent().find('i').removeClass('active');
                }
            }).keyup(function () {
                let $rubbleIcon = $(this).parent().find('i');
                if ($(this).val() === '') {
                    $rubbleIcon.removeClass('active');
                } else {
                    $rubbleIcon.addClass('active');
                }
            });
        }

        this.addInputField('#debtDecreaseTable', 'debtDecrease', {
            dynamic: true,
            appendButtonSelector: "#addDebtDecrease",
            removeSelector: ".dynamic-list-row-remove a",
            keepOne: false,
            prepareTemplate: function ($clone, blockPiece) {
                setTemplate($clone, blockPiece);

                return { block: $clone };
            },
            ignoreForEmpty: true,
            fields: {
                date: {
                    selector: ".dynamic-list-date date-picker",
                    options: function ($clone) {
                        return {
                            errors: [
                                { check: function (v) { return v.valid; }, selector: $clone.find('.dynamic-row-error-date') },
                                { check: function (v) { return !v.goesBefore(new DatePoint("01.01.1995")); }, selector: $clone.find('.from-bound-err')}
                            ]
                        }
                    },
                },
                sum: {
                    selector: ".dynamic-list-sum input",
                    options: function ($clone) {
                        return {
                            type: 'money',
                            errors: [{ check: function (v) { return !!v; }, selector: $clone.find('.dynamic-row-error-sum') }]
                        }
                    },
                },
                comment: {
                    selector: ".dynamic-list-comment input",
                    options: function ($clone) {
                        return {
                            type: 'text'
                        }
                    },
                }
            }
        });

        this.addGroup('debtDecrease', this.decreaseDateCheck, { parentPeriod: this.mainPeriodField });
        this.addGroup('subtractingPeriods', baseDateIntervalCheck, { parent: this.mainPeriodField });

        // add output fields
        this.addOutputField('.periods-detalization', 'detalization', {
            html: true,
            render: function (periods) {
                function renderHeader() {
                    return `<tr class="output-table-header-row"><td>период</td><td>дн.</td><td>ставка,&nbsp;%</td><td>делитель</td><td>пени,&nbsp;${tools.getRubble()}</td>${(self.hasDebtDecrease ? `<td>задолжен.,&nbsp;${tools.getRubble()}</td>` : '')}</tr>`;
                }

                function renderRow(period) {
                    return `<tr class="output-table-add-row"><td class="output-table-add-row-column__left">${period.span.toLocaleFormat()}</td>`
                        + `<td class="output-table-add-row-column__center">${period.days}</td>`
                        + `<td class="output-table-add-row-column__center">${period.rate}</td>`
                        + `<td class="output-table-add-row-column__center">${period.denum}</td>`
                        + `<td class="output-table-add-row-column__right">${tools.getLocaleSum(period.percents)}</td>`
                        + (self.hasDebtDecrease ? `<td class="output-table-add-row-column__right">${tools.getLocaleSum(period.loanSum)}</td></tr>` : '');;
                }

                function renderSubRow(period) {
                    return `<tr class="output-table-sub-data-row"><td colspan="6">${period.span.toLocaleFormat()}</td></tr>`
                        + `<tr class="output-table-sub-info-row"><td colspan="6">Исключаемый период (${tools.verboseCountingValue(period.span.getPeriodDuration().inDays, [['день', 'дня', 'дней']])})</td></tr>`
                        + (period.instance.name ? `<tr class="output-table-sum-comment-row"><td colspan="6" class="output-table-sum-comment-row-column">${period.instance.name}</td></tr>` : '');
                }

                function renderDecreaseRow(period) {
                    return `<tr class="output-table-sum-data-row"><td class="output-table-sum-data-row-column__left">${period.date}</td><td></td><td></td><td></td><td></td><td class="output-table-sum-data-row-column__right">${tools.getLocaleSum(period.newSum)}</td></tr>`
                        + `<tr class="output-table-sum-info-row"><td colspan="6" class="output-table-sum-info-row-column"><span>Частичная&nbsp;оплата&nbsp;долга</span>`
                        + `<span class="output-table-sum-info-row-column-value--decrease">&minus;${tools.getLocaleSumInRubbles(period.value)}</span></td></tr>`
                        + (period.comment ? `<tr class="output-table-sum-comment-row"><td colspan="6" class="output-table-sum-comment-row-column">${period.comment}</td></tr>` : '');
                }

                const table = document.createElement('table');
                table.classList.add('output-table');

                let inner = "";
                inner += renderHeader();
                periods.forEach(function (period, i) {
                    switch(period.type){
                        case "add":
                            inner += renderRow(period);
                            break;
                        case "sub":
                            inner += renderSubRow(period);
                            break;
                        case "decrease":
                            inner += renderDecreaseRow(period);
                            break;  
                        default:
                            console.log(`Unknown Row Type - ${period.type}`);
                            break;
                    }
                });

                table.innerHTML = inner;
                return table.outerHTML;
            }
        });

        function _travm() {
            return self.paymentType.value === "Travmatizm";
        }

        this.addOutputField('.period-render', 'resultPeriod', {
            type: 'period', render: function (period) {
                const duration = tools.verboseCountingValue(period.duration.inDays, [['день', 'дня', 'дней']]);
                const comment = (self.subtractingPeriods.length > 0 ? ' с учётом исключаемых периодов' : '');
                return `с ${period.dateFrom.toLocaleFormat()} по ${period.dateTo.toLocaleFormat()} (${duration}${comment})`;
            }
        });

        var crownDays = makeDateSegmentWorker(crownRegionalHolidays);
        this.addOutputField('#covid-regional-holidays', '', { type: 'note', render: function () { return crownDays.checkDay(self.mainPeriod.dateFrom.addDays(-1), true) && !_travm() } });

        this.addOutputField('#last-day-included-injury', '', { type: 'note', render: function () { return self.info.lastDayIncluded && _travm(); } });
        this.addOutputField('#last-day-included-before-2023', '', { type: 'note', render: function () { return self.info.lastDayIncluded && !_travm() && self.isBefore2023 && self.isBefore2023.to; } });
        this.addOutputField('#last-day-included', '', { type: 'note', render: function () { return self.info.lastDayIncluded && !_travm() && (!self.isBefore2023 || !self.isBefore2023.to); } });
        this.addOutputField('#last-day-not-included', '', { type: 'note', render: function () { return !self.info.lastDayIncluded; } });

        this.addOutputField('#special-calculation', '', {type: 'note', render: function () {return self.specialCalculationNoteShow && self.resultPeriod.duration.inDays > 30}});
        this.addOutputField('#note-from-2023', '', {type: 'note', render: function () {return !_travm() && self.mainPeriod.dateFrom.distanceTo(new DatePoint("2023.01.01")) <= 1}});

        this.addOutputField('#unpredictable-future', '', { type: 'note', render: function () { 
            if (self.dateFutureAlertWorker.getState() === 'closed') {
                return true;
            } else if (self.dateFutureAlertWorker.isVisible()) {
                return 'print';
            }
        }});

        function _alertHelper(needTravm, name) {
            if ((_travm() ^ needTravm) || !self.futureAlertState.valid || self.futureAlertState.cn !== name) return false;
            return self.futureAlertState.printOnly ? 'print' : true;
        }

        function _holidaysDetermineHelper(holidays, alertHelper, ignoreHolidays) {
            let date = new DatePoint((self.dateFromAlertWorker.getState() === 'accept') ? $(".datefrom-alert-val-render").html() : self.mainPeriod.dateFrom).copy().dec()
            const crownDays = makeDateSegmentWorker(holidays);
            if(date.isDayOff() && !ignoreHolidays) {
                date = nextDateAfterWorkingDay(date);
            }
            const holidayNoteIsShowed = holidays.length ? crownDays.checkDay(date, !ignoreHolidays) : true;
          
            return alertHelper == "print" && holidayNoteIsShowed ? 'print' : holidayNoteIsShowed && alertHelper;
        }
        var crownAdditionalMayHolidays = [
            { from: "2021.05.01", to: "2021.05.06" }
        ];
        
        const crownBasicRegionalMayNovemberHolidays = crownBasicHolidays.concat(crownRegionalHolidays, crownMayHolidays, crownNovemberHolidays);

        this.addOutputField('#first-holiday-unchanged-before-2023', '', { type: 'note', render: function () { 
            return _alertHelper(false, 'first-holiday-unchanged-before-2023') } 
        });
        this.addOutputField('#first-holiday-unchanged', '', { type: 'note', render: function () { 
            return _alertHelper(false, 'first-holiday-unchanged') } 
        });
        this.addOutputField('#first-holiday-changed-before-2023', '', { type: 'note', render: function () {
            return _alertHelper(false, 'first-holiday-changed-before-2023'); } 
        });
        this.addOutputField('#first-holiday-changed', '', { type: 'note', render: function () {
            return _alertHelper(false, 'first-holiday-changed'); } 
        });
        this.addOutputField('#first-holiday-unchanged-travm', '', { type: 'note', render: function () { 
            return _alertHelper(true, 'first-holiday-unchanged'); } 
        });
        this.addOutputField('#first-holiday-changed-travm', '', { type: 'note', render: function () {
             return _alertHelper(true, 'first-holiday-changed'); } 
        });
        this.addOutputField('#covid-holiday-changed', '', { type: 'note', render: function () { 
            return _holidaysDetermineHelper(crownBasicHolidays.concat(crownRegionalHolidays, crownNovemberHolidays), _alertHelper(false, 'covid-holiday-changed')); 
        } });
        this.addOutputField('#covid-off-holiday-changed', '', { type: 'note', render: function () {
            return _holidaysDetermineHelper(crownBasicRegionalMayNovemberHolidays.concat(crownAdditionalMayHolidays), _alertHelper(false, 'covid-off-holiday-changed')); } 
        });
        this.addOutputField('#covid-off-holiday-unchanged', '', { type: 'note', render: function () {
            return _holidaysDetermineHelper(crownBasicRegionalMayNovemberHolidays.concat(crownAdditionalMayHolidays), _alertHelper(false, 'covid-off-holiday-unchanged')); 
        } });
        this.addOutputField('#covid-holiday-unchanged', '', { type: 'note', render: function () { 
            return _holidaysDetermineHelper(crownBasicRegionalMayNovemberHolidays, _alertHelper(false, 'covid-holiday-unchanged')); } 
        });
        
        this.addOutputField('#covid-parade-holidays-unchanged', '', { type: 'note', render: function () { 
            return _holidaysDetermineHelper(crownParadeHolidays, _alertHelper(false, 'covid-holiday-unchanged')); 
        } });
        this.addOutputField('#covid-parade-holidays-changed', '', { type: 'note', render: function () { 
            return _holidaysDetermineHelper(crownParadeHolidays, _alertHelper(false, 'covid-holiday-changed') ); 
        } });
       
        this.addOutputField('#covid-election-holidays-unchanged', '', { type: 'note', render: function () { 
            return _holidaysDetermineHelper(crownElectionHolidays, _alertHelper(false, 'covid-holiday-unchanged')); 
        } });
        this.addOutputField('#covid-election-holidays-changed', '', { type: 'note', render: function () { 
            return _holidaysDetermineHelper(crownElectionHolidays, _alertHelper(false, 'covid-holiday-changed')); 
        } });
        
        this.addOutputField('#covid-may-holidays-changed', '', { type: 'note', render: function () { 
            return _holidaysDetermineHelper(crownMayHolidays, _alertHelper(false, 'covid-holiday-changed')); 
        } });
        
        this.addOutputField("#covid-travm", '', { type: 'note', render: function () { 
            return _holidaysDetermineHelper(crownBasicHolidays.concat(crownMayHolidays, crownNovemberHolidays), _travm())
        } });
        this.addOutputField("#rule-ip-1", '', {
            type: "toggle",
            render: () => this.shownRules.some((s) => s == "rule-ip-1")
        });
        this.addOutputField("#rule-ip-2", '', {
            type: "toggle",
            render: () => this.shownRules.some((s) => s == "rule-ip-2")
        });
        this.addOutputField("#rule-org-1", '', {
            type: "toggle",
            render: () => this.shownRules.some((s) => s == "rule-org-1")
        });
        this.addOutputField("#rule-org-2", '', {
            type: "toggle",
            render: () => this.shownRules.some((s) => s == "rule-org-2")
        });
        this.addOutputField("#rule-table", '', {
            type: "toggle",
            render: () => this.shownRules.some((s) => s == "rule-table")
        });
        this.addOutputField("#rule-thead-1", '', {
            type: "toggle",
            render: () => !this.shownRules.some((s) => s == "rule-tr-4")
        });
        this.addOutputField(".rule-thead-2", '', {
            type: "toggle",
            render: () => this.shownRules.some((s) => s == "rule-tr-4")
        });
        this.addOutputField("#rule-tr-1", '', {
            type: "toggle",
            render: () => this.shownRules.some((s) => s == "rule-tr-1")
        });
        this.addOutputField("#rule-tr-2", '', {
            type: "toggle",
            render: () => this.shownRules.some((s) => s == "rule-tr-2")
        });
        this.addOutputField("#rule-tr-3", '', {
            type: "toggle",
            render: () => this.shownRules.some((s) => s == "rule-tr-3")
        });
        this.addOutputField("#rule-tr-4", '', {
            type: "toggle",
            render: () => this.shownRules.some((s) => s == "rule-tr-4")
        });
        this.addOutputField("#rule-travm", '', {
            type: "toggle",
            render: () => this.shownRules.some((s) => s == "rule-travm")
        });
      
        var alertOptions = {
            slideUpDuration: 200,
            crownPeriods: crownHolidays,
            alertAcceptSelector: $('.button-normal'),
            minCheckDate: '01.01.2021',
            isDynamicSubmit: true,
            submitForm: function () { self.submitForm(null, true); /*document.getElementById('dateFrom'), true);*/ }
        };
        this.dateFromAlertWorker = makeDateFromAlertWorker(alertOptions);
        this.dateFutureAlertWorker = makeDateInFutureAlertWorker(alertOptions);
        
        this.addDynamicField('subtractingPeriods', {
            table: "#subPeriodsTable",
            appendButtonSelector: "#addSubPeriods",
            removeSelector: ".dynamic-list-row-remove a",
            keepOne: false,
            prepareTemplate: function($clone, blockPiece){
                $clone.data('rowIndex', blockPiece.index + 1);

                var $comment = $clone.find('.dynamic-list-comment input').change(function () {
                    $(this).data('changed', '1');
                }).focus(tools.selectAllText);
                
                $comment.val($comment.val() + $clone.data('rowIndex'));

                return { block: $clone };
            }
        });

        this.isBefore2023 = {
            from: false,
            to: false
        };

        this.loadDescription();

        this.submitOnClick('#calcSubmit');
        this.addResetButton("#clearCalcInput");
    }

    isReady() {
        return this.refinRates !== undefined;
    }

    onReset() {
        $("#avans2023Err").hide();
        $('.calc-div-results').removeClass('show-results');

        $("#loan-sum-tooltip-div > button").css('visibility', '');

        $(".none-p3").removeClass("hidden");
        $(".only-p3").addClass("hidden");

        this.isBefore2023 = {
            from: false,
            to: false
        };

        this.dateFromAlertWorker.reset();
        this.dateFutureAlertWorker.reset();

        this.shownRules = [];
    }

    includeLastDay(dateFrom, paymentType) {
        if (!this._judgementDate.goesBefore(dateFrom) && paymentType !== "Travmatizm") {
            return false;
        }
        return true;
    }

    generateExportObject() {
        let self = this;
        let result = super.generateExportObject();
        result.shownRules = this.shownRules;
        result.penalty = this.resultPenalty;
        result.hasDebtDecrease = this.hasDebtDecrease;
        result.isExcess = this.isExcess;
        result.render.detalization = tools.deepcopy(this.detalization);
        result.render.detalization.forEach(function (period, index) {
            if (period.type === 'add')
                period.period = self.detalization[index].span.toLocaleFormat();
            else if (period.type === 'sub') {
                period.period = self.detalization[index].span.toLocaleFormat();
                period.comment = `Исключаемый период (${self.detalization[index].span.getPeriodDuration().inDays} дн.)`;
            }
        });
        return result;
    }

    showResults() {
        let $notes = $(".note-block-list");
        if ($('.note-block.active').length > 0) {
            $notes.show();
        } else {
            $notes.hide();
        }

        super.showResults();

        var goalParams = {
            args:{
                Vid_platezha: this.paymentType.value,
                Platelschik: this.payer.value,
                Date_from: this.mainPeriod.dateFrom,
                Date_to: this.mainPeriod.dateTo,
                Not_included_period: this.subtractingPeriods.length > 0,
                Date_Future: this.dateFutureAlertWorker.shown(),
                Show_Day_Off_Option: this.dateFromAlertWorker.shown() || this.dateFromAlertWorker.isAccepted() || this.dateFromAlertWorker.isClosed(),
                Check_Day_Off_Option: this.dateFromAlertWorker.isAccepted(),
            },
            message: 'Is_Made'
        };
        this.sendStatisticMessage(goalParams);
    }

    afterParse(sender, autoValidation) {
        if (this.paymentType && this.paymentType.value == 'Travmatizm') {
            $("#loan-sum-tooltip-div > button").css('visibility', 'hidden');
        } else {
            $("#loan-sum-tooltip-div > button").css('visibility', '');
        }

        if (this.mainPeriodField !== undefined) {
            let period = this.mainPeriodField.getValue(true);

            if (sender && (sender.id === "dateFrom" || sender.id == "paymentType")) {
                this.dateFromAlertWorker.check(period.dateFrom.date, this.paymentType ? this.paymentType.value == "Travmatizm" : false);
            }

            if (this.paymentType && this.paymentType.value == 'Avans') {
                this.dateFutureAlertWorker.hide();
            } else {
                if (sender && (sender.id === "dateTo" || sender.id === "paymentType")) {
                    this.dateFutureAlertWorker.check(period.dateTo.date);
                }
            }

            if (!this.mainPeriodField.includeEnd.to) {
                $("#lastDayNotIncludedError").show();
            } else {
                $("#lastDayNotIncludedError").hide();
            }

            // add error for avans payments after the beggining of 2023
            const avans2023Err = $("#avans2023Err");
            if (this.paymentType && this.mainPeriodField.valid) {
                if (this.paymentType.value == "Avans" && this.mainPeriodField.dateTo.distanceTo(new DatePoint("2023.01.01")) <= 1) {
                    avans2023Err.show();
                    this.mainPeriodField.elemTo.addClass("err");
                } else {
                    this.mainPeriodField.elemTo.removeClass("err");
                    avans2023Err.hide();
                }
            } else {
                avans2023Err.hide();
            }

            this.setCrownLinks();
        }
    }

    setCrownLinks(isRender = false) {
        const currentDateFrom = new DatePoint(this.dateFromAlertWorker.isAccepted() ? this.dateFromAlertWorker.getFrozenDateFrom() : this.mainPeriodField.getValue(true).dateFrom).copy().dec();
        const crown2020 = makeDateSegmentWorker(crownBasicHolidays.concat(crownParadeHolidays, crownElectionHolidays));
        const crown2021nov = makeDateSegmentWorker(crownNovemberHolidays);
        const crown2021may = makeDateSegmentWorker(crownMayHolidays);

        const crownHolidaysLinksBlock = $(isRender ? ".note-block .crown-holiday-link" : "#dateFromAlert .crown-holiday-link");
        const crownHolidaysOnlyLinksBlock = crownHolidaysLinksBlock.filter(":not(.permalink)");
        const crownHolidaysPermalinksBlock = crownHolidaysLinksBlock.filter(".permalink");
   
        const dayForCheck = currentDateFrom.isDayOff() ? nextDateAfterWorkingDay(currentDateFrom) : currentDateFrom;
        if (crown2020.checkDay(dayForCheck, true)) { //for 2020 period
            crownHolidaysOnlyLinksBlock.replaceWith($(".crown-links .basicCrownHolidaysLink:not(.permalink)")[0].outerHTML);
            crownHolidaysPermalinksBlock.replaceWith($(".crown-links .basicCrownHolidaysLink.permalink")[0].outerHTML);
        } else if (crown2021nov.checkDay(dayForCheck, true)) { //for 2021 november period
            crownHolidaysOnlyLinksBlock.replaceWith($(".crown-links .otherNovemberCrownHolidaysLink:not(.permalink)")[0].outerHTML);
            crownHolidaysPermalinksBlock.replaceWith($(".crown-links .otherNovemberCrownHolidaysLink.permalink")[0].outerHTML);
        } else if (crown2021may.checkDay(dayForCheck, true)) { //for 2021 may period
            crownHolidaysOnlyLinksBlock.replaceWith($(".crown-links .otherMayCrownHolidaysLink:not(.permalink)")[0].outerHTML);
            crownHolidaysPermalinksBlock.replaceWith($(".crown-links .otherMayCrownHolidaysLink.permalink")[0].outerHTML);
        }
        else { //for the rest of 2021 period
            crownHolidaysOnlyLinksBlock.replaceWith($(".crown-links .otherCrownHolidaysLink:not(.permalink)")[0].outerHTML);
            crownHolidaysPermalinksBlock.replaceWith($(".crown-links .otherCrownHolidaysLink.permalink")[0].outerHTML);
        }
        
        if (isRender) {
            const additionalCrownLinksBlock = $(".note-block .additional-crown-links");
            if (crown2020.checkDay(dayForCheck, true)) { //for 2020 period
                additionalCrownLinksBlock.replaceWith($(".crown-links .additionalBasicCrownLinks")[0].outerHTML);
            } else if (crown2021nov.checkDay(dayForCheck, true)) { //for 2021 november period
                additionalCrownLinksBlock.replaceWith('<span class="additional-crown-links"></span>');
            } else if (crown2021may.checkDay(dayForCheck, true)) { //for 2021 may period
                additionalCrownLinksBlock.replaceWith('<span class="additional-crown-links"></span>');
            }
            else { //for the rest of 2021 period
                additionalCrownLinksBlock.replaceWith('<span class="additional-crown-links"></span>');
            }
        }
    }

    afterFirstPhaseCheck() {
        if (this.paymentType !== undefined) {
            if (this.paymentType.value === "Travmatizm") {
                $('.datefrom-travm-case').removeClass('hidden');
                $('.datefrom-all-cases').addClass('hidden');
            } else {
                $('.datefrom-travm-case').addClass('hidden');
                $('.datefrom-all-cases').removeClass('hidden');
            }

            $('#dateTo').attr('tooltip', this.paymentType.value === "Nalog" ? '#nalog-tooltip' : '');
            var p3 = this.paymentType.value === "Travmatizm";
            $(".none-p3").toggleClass("hidden", p3);
            $(".only-p3").toggleClass("hidden", !p3);
        }

        if(this.mainPeriodField && this.mainPeriodField.dateFrom.valid) {
            const crownDaysParade = makeDateSegmentWorker(crownParadeHolidays);
            const crownDaysElection = makeDateSegmentWorker(crownElectionHolidays);
            const dateFrom = this.mainPeriodField.dateFrom.copy().dec();
            $(".common-rules, .election-holidays, .parade-holidays").hide();

            if (crownDaysParade.checkDay(dateFrom)) {
                $(".parade-holidays").show();
            } else if (crownDaysElection.checkDay(dateFrom)) {
                $(".election-holidays").show();
            } else {
                $(".common-rules").show();
            }
        }

        const rateBreakpoint2023 = new DatePoint("2023.01.01");
        this.isBefore2023 = {
            from: !!(this.mainPeriod && this.mainPeriod.dateFrom.valid && this.mainPeriod.dateFrom.distanceTo(rateBreakpoint2023) > 1),
            to: !!(this.mainPeriod ? this.mainPeriod.dateTo.valid && this.mainPeriod.dateTo.distanceTo(rateBreakpoint2023) > 1 :
                this.mainPeriodField.dateTo.date && this.mainPeriodField.dateTo.distanceTo(rateBreakpoint2023) > 1)
        };
    }

    beforeRender() {
        const self = this;
        this.futureAlertState = {
            cn: "first-holiday-unchanged",
            valid: true,
            printOnly: false
        };
        
        const isAccepted = this.dateFromAlertWorker.isAccepted();
        const isAcceptedCrown = this.dateFromAlertWorker.isAcceptedCrown();
        const isDayOffCrown = this.dateFromAlertWorker.isDayOffCrown(isAccepted);
        const isDayCrown = this.dateFromAlertWorker.isDayCrown(isAccepted);

        if (this.paymentType.value != "Travmatizm") {
            if (isDayOffCrown && isAccepted && isAcceptedCrown) {
                this.futureAlertState.cn = "covid-off-holiday-changed";
            } else if (isDayCrown && isAccepted) {
                this.futureAlertState.cn = "covid-holiday-changed";
            } else if (isDayCrown) {
                this.futureAlertState.cn = "covid-holiday-unchanged";
            } else if (isAccepted) {
                if (this.isBefore2023 && this.isBefore2023.from)
                    this.futureAlertState.cn = "first-holiday-changed-before-2023";
                else
                    this.futureAlertState.cn = "first-holiday-changed";
            } else if (isDayOffCrown) {
                this.futureAlertState.cn = "covid-off-holiday-unchanged";
            } else if (this.isBefore2023 && this.isBefore2023.from)
                this.futureAlertState.cn = "first-holiday-unchanged-before-2023";
        } else if (this.dateFromAlertWorker.getState() === 'accept') {
            this.futureAlertState.cn = "first-holiday-changed";
        }
        
        if (this.dateFromAlertWorker.isVisible()) {
            this.futureAlertState.printOnly = true;
        } else if (this.dateFromAlertWorker.getState() !== 'closed' && this.dateFromAlertWorker.getState() !== 'accept' ) {
            this.futureAlertState.valid = false;
        }
        
        if (this.futureAlertState.valid) {
            this.dateFromAlertWorker.render(this.futureAlertState.printOnly);
        }

        this.setCrownLinks(true)
    }

    get defaultFilled(){
        return $("#subPeriodsTable").find('.dynamic-list-row').length > 0;
    }

    decreaseDateCheck(fields, options) {
        let result = {
            valid: true
        }
        
        let debtInfo = new Object();
        debtInfo.decreaseGroups = [];
        debtInfo.hasDebtDecrease = false;

        let decreaseFields = fields.tree.debtDecrease || [];

        if (fields.length > 0) {
            const decreaseGroups = [];

            if (decreaseFields.length > 0) {
                decreaseFields.forEach(function (field) {
                    if (field.date) {
                        let group = { dateField: field.date, sumField: field.sum, isIncrease: false, valid: true, commentField: field.comment };
                        decreaseGroups.push(group);
                        if (group.dateField.valid && group.sumField.valid) {
                            debtInfo.hasDebtDecrease = true;
                        }
                    }
                });
            }

            decreaseGroups.sort(function (a, b) {
                return (a.dateField && a.dateField.getValue().goesBefore(b.dateField.getValue()) ? -1 : 1);
            });

            decreaseGroups.forEach(function (group, index) {
                let elem = group.dateField.elem;
                let $error = $(elem).closest("tr.dynamic-list-row").find(".dynamic-row-error");

                $error.hide();
                if (group.dateField.valid) {
                    elem.removeClass('err');
                }

                let date = group.dateField.getValue();
                let sumElem = group.sumField.elem;
                if (options.parentPeriod.valid && group.dateField.valid) {
                    if (date.goesBefore(options.parentPeriod.dateFrom) || options.parentPeriod.dateTo.goesBefore(date)) {
                        elem.addClass('err');
                        $error.html('Дата ' + (group.isIncrease ? 'увеличения долга' : 'частичной оплаты') + ' не может быть '
                            + (options.parentPeriod.dateTo.goesBefore(date) ? 'позже' : 'раньше') + ' периода начисления пени');
                        $error.show();

                        let $sumError = $(sumElem).closest("tr.dynamic-list-row").find(".dynamic-row-error-sum");
                        $sumError.hide();

                        result.valid = group.valid = false;
                    }
                }

                debtInfo.decreaseGroups.push(group);

                if (group.valid) {
                    $error.hide();
                }
            });
        }

        result.artifacts = debtInfo;

        return result;
    }

    calculate(params) {
        let self = this;

        if (params.autoValidation) {
            return false;
        }

        if (this.paymentType.value == "Avans" && this.mainPeriod.dateTo.distanceTo(new DatePoint("2023.01.01")) <= 1)
            return false;

        this.resultPenalty = 0;
        this.initialLoanSum = this.loanSum;
        this.detalization = [];
        this.info = { lastDayIncluded: this.includeLastDay(this.mainPeriod.dateFrom, this.paymentType.value) };

        this.subtractingPeriods = (this.subtractingPeriods || []).sort(function (a, b) {
            return (a.period.dateFrom.goesBefore(b.period.dateFrom) ? -1 : 1);
        });
        
        var accumDays = 0;
        self.specialCalculationNoteShow = false;

        function getPeriodDates(dateFrom, dateTo, ratesObj) {
            const dates = [dateFrom, dateTo];

            for (let i = ratesObj.length - 1; i >= 0; i--) {
                const date = new DatePoint(ratesObj[i].date);
                if (dateFrom.goesBefore(date) && date.goesBefore(dateTo)) {
                    dates.push(date);
                }
            }

            const specialDate = new DatePoint("01.01.2025");
            if (dateFrom.goesBefore(specialDate) && specialDate.goesBefore(dateTo)) {
                dates.push(specialDate);
            }

            return distinctDates(dates);
        }

        function addPeriod(span, rate) {
            function addPeriodWithDenum(span, rate, denum) {
                var days = span.getDayCount();
                var percents = self.loanSum * (rate / 100) * days / denum;
                percents = Number(tools.roundNumber(percents, 2));
                self.resultPenalty += percents;
                self.detalization.push({
                    span: span,
                    days: days,
                    rate: tools.getLocaleNumber(rate),
                    denum: denum,
                    loanSum: self.loanSum,
                    percents: percents,
                    type: "add"
                });
            }
            const specialDateSpan =  new DateSpan("09.03.2022", "31.12.2024");
            const specialCalculationRule = specialDateSpan.intersects(span);
            const afterSpecialCalculation = specialDateSpan.dateTo.goesBefore(span.dateFrom);
            
            if (self.payer.value === "Org" && self.paymentType.value !== "Travmatizm" && !self.mainPeriod.dateFrom.goesBefore("01.10.2017")) {
                function addTablePeriod(span, isSpecialCalculation, isAfterSpecialCalculation) {
                    const spanDays = span.getDayCount();
                    if (isSpecialCalculation) {
                        addPeriodWithDenum(span, rate, 300);
                        accumDays += spanDays;
                        if (accumDays > 30) {
                            self.specialCalculationNoteShow = true;
                        }
                    } else if (isAfterSpecialCalculation && accumDays >= 90) {
                        addPeriodWithDenum(span, rate, 300);
                    } else if (!isAfterSpecialCalculation && accumDays >= 30) {
                        addPeriodWithDenum(span, rate, 150);
                    } else {
                        let point1 = span.dateFrom.addDays(0);
                        if (accumDays < 30) {
                            point1 = span.dateFrom.addDays(30 - accumDays);
                            if (span.dateTo.goesBefore(point1)) {
                                addPeriodWithDenum(span, rate, 300);
                                accumDays += spanDays;
                                return;
                            }
                            else if (point1.addDays(-1).goesBefore(span.dateTo))
                                addPeriodWithDenum(span.dateFrom.getSpan(point1.addDays(-1)), rate, 300);
                        }
                        let point2 = span.dateFrom.addDays(accumDays < 90 ? 90 - accumDays : 0);
                        if (isAfterSpecialCalculation && point2.addDays(-1).goesBefore(span.dateTo)) {
                            addPeriodWithDenum(point1.getSpan(point2.addDays(-1)), rate, 150);
                            addPeriodWithDenum(point2.getSpan(span.dateTo), rate, 300);
                        } else {
                            addPeriodWithDenum(point1.getSpan(span.dateTo), rate, 150);
                        }
                        accumDays += spanDays;
                    }
                }

                if(specialCalculationRule) { // we split current period by segments depends on location 
                    if (span.inside(specialDateSpan)) { // specialDateFrom spanDateFrom spanDateTo specialDateTo
                        addTablePeriod(span, true);
                    } else if (specialDateSpan.inside(span)) { // spanDateFrom specialDateFrom specialDateTo spanDate
                        addTablePeriod(new DateSpan(span.dateFrom, specialDateSpan.dateFrom.addDays(-1)));
                        addTablePeriod(specialDateSpan, true);
                        addTablePeriod(new DateSpan(specialDateSpan.dateTo.addDays(1), span.dateTo));
                    } else if (!span.dateFrom.goesBefore(specialDateSpan.dateFrom) && !span.dateTo.goesBefore(specialDateSpan.dateTo)) { //specialDateFrom spanDateFrom specialDateTo spanDateTo
                        const spanBeforeSpecialDateTo = new DateSpan(span.dateFrom, specialDateSpan.dateTo);
                        if (spanBeforeSpecialDateTo.getDayCount() + accumDays <= 30) {
                            addTablePeriod(span);
                        } else {
                            addTablePeriod(new DateSpan(span.dateFrom, specialDateSpan.dateTo), true);
                            addTablePeriod(new DateSpan(specialDateSpan.dateTo.addDays(1), span.dateTo), false, afterSpecialCalculation);
                        }
                    } else { // spanDateFrom specialDateFrom spanDateTo specialDateTo
                        const spanBeforeSpecialDateFrom = new DateSpan(span.dateFrom, specialDateSpan.dateFrom.addDays(-1)); 
                        if (spanBeforeSpecialDateFrom.getDayCount() + accumDays <= 30) {
                            addTablePeriod(new DateSpan(span.dateFrom, span.dateTo), true);
                        } else {
                            addTablePeriod(new DateSpan(span.dateFrom, specialDateSpan.dateFrom.addDays(-1)));
                            addTablePeriod(new DateSpan(specialDateSpan.dateFrom, span.dateTo), true);
                        }
                    }
                } else {
                    addTablePeriod(span, false, afterSpecialCalculation);
                }
            } else {
                addPeriodWithDenum(span, rate, 300);
            }
        }

        function getRate(date, rates) {
            for (let i = rates.length - 1; i >= 0; i--) {
                if (!new DatePoint(date).goesBefore(rates[i].date)) {
                    return rates[i].rate;
                }
            }

            return 0;
        }

        function fixPeriod(dateFrom, dateTo) {
            var result_ = dateFrom.getSpan(dateTo);

            var subtractingPeriodsDays = self.subtractingPeriods.map(function (sub) {
                return sub.period.dateFrom.distanceTo(sub.period.dateTo);
            }).reduce(function (a, b) { return a + b; }, 0);

            result_.duration = result_.getPeriodDuration(subtractingPeriodsDays);
            return result_;
        }

        const dateToNexDay = this.mainPeriod.dateTo.copy().inc();
        const dates = getPeriodDates(this.mainPeriod.dateFrom, dateToNexDay, this.refinRates);

        const uniqueDecreaseDates = [];
        this.decreaseGroups.forEach((group) => {
            let date = group.dateField.getValue();
            if (uniqueDecreaseDates.indexOf(date) < 0) {
                uniqueDecreaseDates.push(date);
                dates.push(date.inc());
            }
        });

        function splitSubtractionPeriods() {
            if (!uniqueDecreaseDates.length) {
                return self.subtractingPeriods.map(x => x.period);
            }

            const result = [];
            self.subtractingPeriods.forEach((sub) => {
                const filteredDates = distinctDates(uniqueDecreaseDates.filter(x => !x.copy().dec().goesBefore(sub.period.dateFrom) && !sub.period.dateTo.goesBefore(x)));
                const subDates = [sub.period.dateFrom, ...filteredDates, sub.period.dateTo];
                subDates.forEach((_subDate, i, arr) => {
                    if (i === arr.length - 1) {
                        return;
                    }
                    result.push({
                        dateFrom: arr[i].copy(),
                        dateTo: arr[i + 2] ? arr[i + 1].copy().dec() : arr[i + 1].copy(),
                        includeEnd: sub.period.includeEnd,
                        name: sub.period.name,
                    });
                });
            });
            
            return result;
        }

        const finalSubtractionPeriods = splitSubtractionPeriods();

        self.resultPeriod = fixPeriod(this.mainPeriod.dateFrom, this.mainPeriod.dateTo);
        this.isExcess = false;
        self.resultPeriod.getDateSegments({
            keypoints: distinctDates(dates),
            subtract: finalSubtractionPeriods
        }).every(function (segment) {
            if (segment.type === 'add') {
                addPeriod(segment.span, segment.leftKey == null ? 0 : getRate(segment.leftKey.date, self.refinRates));
            } else {
                self.detalization.push(segment);
            }

            self.decreaseGroups.forEach((group) => {
                const date = group.dateField.getValue();
                const sum = group.sumField.getValue();
                if (segment.span.dateTo.isEqualTo(date)) {
                    self.loanSum = tools.roundNumber(self.loanSum - sum, 2);
                    self.detalization.push({
                        date: segment.span.dateTo.toLocaleFormat(),
                        value: sum,
                        newSum: self.loanSum > 0 ? self.loanSum : 0,
                        type: "decrease",
                        year: segment.span.dateTo.date.getFullYear(),
                        comment: group.commentField.getValue(),
                    });
                }
            });

            if (self.loanSum <= 0) {
                if (self.loanSum < 0) {
                    self.isExcess = true;
                    self.loanSum = 0;
                    self.finalDate = segment.span.dateTo.toLocaleFormat()
                }
                self.resultPeriod = fixPeriod(self.mainPeriod.dateFrom, segment.span.dateTo);
                return false;
            }

            return true;
        });

        this.resultPenalty = Number(tools.roundNumber(this.resultPenalty, 2))

        this.shownRules = [];

        if (this.paymentType.value === "Travmatizm")
            this.shownRules.push("rule-travm");
        else {
            if (this.payer.value === "Ip_fl") {
                if (this.mainPeriodField.dateFrom.distanceTo(new DatePoint("2023.01.01")) > 1)
                    this.shownRules.push("rule-ip-1");
                if (this.mainPeriodField.dateTo.distanceTo(new DatePoint("2023.01.01")) <= 1)
                    this.shownRules.push("rule-ip-2");
            } else {
                this.shownRules.push("rule-table");
                if (this.mainPeriodField.dateFrom.distanceTo(new DatePoint("2023.01.01")) > 1)
                    this.shownRules.push("rule-org-1");
                if (this.mainPeriodField.dateTo.distanceTo(new DatePoint("2023.01.01")) <= 1)
                    this.shownRules.push("rule-org-2");
                if (this.mainPeriodField.dateFrom.distanceTo(new DatePoint("2017.10.01")) > 1)
                    this.shownRules.push("rule-tr-1");
                else {
                    if (this.mainPeriodField.dateFrom.distanceTo(new DatePoint("2022.03.09")) > 1 &&
                        this.mainPeriodField.dateTo.distanceTo(new DatePoint("2017.10.01")) <= 1)
                        this.shownRules.push("rule-tr-2");
                    if (this.mainPeriodField.dateFrom.distanceTo(new DatePoint("2025.01.01")) > 1 &&
                        this.mainPeriodField.dateTo.distanceTo(new DatePoint("2022.03.09")) <= 1)
                        this.shownRules.push("rule-tr-3");
                    if (this.mainPeriodField.dateTo.distanceTo(new DatePoint("2025.01.01")) <= 1)
                        this.shownRules.push("rule-tr-4");
                }
            }
        }

        return true;
    }
}

$(function () {
    var calc = new TFPCalculator();
});